import React from 'react';

var ListViewSelector = React.createClass({
	handleClick: function(e){
		this.props.onInput(true); // this will set the property of viewselector(true or false) in Application
	},
  render: function(){
  	var classes;
  	if(this.props.listview){
  		classes = "views__item views__item--list active"
  	}
  	else{
  		classes = "views__item views__item--list"
  	}
    return(
          <div className={classes} onClick = {this.handleClick}>
              <a href="javascript:void(0)">
                  <i className="fa fa-th-list" />
              </a>
          </div>
    );
  }
});

export {ListViewSelector}


/** WEBPACK FOOTER **
 ** ./html/components/ListViewSelector.jsx
 **/